import { Col, DatePicker, Form, Row, Select } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import InputNumber from "../../../../../components/Input/InputNumber.tsx"
import { DocumentCard } from "../../../../../components/Proposal&Contracts/DocumentCard.tsx"
import { useDateFormat } from "../../../../../hooks/use-date-format.ts"
import { dateAutoFill } from "../../../../../utils/form/date-auto-fill.tsx"
import { validateNumber } from "../../../../../utils/validation/number.ts"
import type { ContractFormData } from "../contract-form-data.tsx"
import { TextArea } from "../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"
interface ContractProjectOverviewSectionProps {
  form: FormInstance<ContractFormData>
}

export function ContractProjectOverviewSection({
  form
}: ContractProjectOverviewSectionProps) {
  const { getDateValueProps, createDateRangeRules } = useDateFormat()

  const key: keyof ContractFormData = "project"

  // const startDate = Form.useWatch([key, "start_date"], form)
  // const completionDate = Form.useWatch([key, "completion_date"], form)

  // todo for future
  // useEffect(() => {
  //   if (startDate && completionDate) {
  //     const daysDiff = dayjs(completionDate).diff(dayjs(startDate), "day") + 1
  //
  //     let duration: number
  //     let period: "days" | "weeks" | "months"
  //
  //     if (daysDiff >= 28) {
  //       // Якщо близько до місяців (28+ днів)
  //       duration = Math.round(daysDiff / 30)
  //       period = "months"
  //     } else if (daysDiff >= 7) {
  //       // Якщо близько до тижнів (7+ днів)
  //       duration = Math.round(daysDiff / 7)
  //       period = "weeks"
  //     } else {
  //       duration = daysDiff
  //       period = "days"
  //     }
  //
  //     duration = Math.max(1, duration)
  //
  //     form.setFieldsValue({
  //       [key]: {
  //         duration: duration?.toString(),
  //         duration_type: period
  //       }
  //     })
  //   }
  // }, [startDate, completionDate, form, key])

  return (
    <DocumentCard title={"Project Overview"} name={key} withToggle={false}>
      <Row gutter={[12, 0]}>
        <Col span={12}>
          <Form.Item<ContractFormData>
            name={[key, "project_type"]}
            label="Project Type"
            rules={[
              {
                required: true,
                whitespace: true,
                message: "Please input project type"
              }
            ]}
          >
            <TextInput disabled placeholder="Enter project type" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item<ContractFormData>
            name={[key, "duration"]}
            label="Duration"
            dependencies={[
              [key, "start_date"],
              [key, "completion_date"]
            ]}
            rules={[
              { required: false, message: "Required" },
              { validator: validateNumber }
              // todo for future
              // ({ getFieldValue }) => ({
              //   validator(_, value) {
              //     const startDate = getFieldValue([key, "start_date"])
              //     const completionDate = getFieldValue([key, "completion_date"])
              //     const period = getFieldValue([key, "duration_type"]) || "days"
              //
              //     if (startDate && completionDate && value) {
              //       const daysDiff =
              //         dayjs(completionDate).diff(dayjs(startDate), "day") + 1
              //
              //       // Конвертуємо введене значення в дні
              //       let valueInDays = value
              //       if (period === "weeks") valueInDays = value * 7
              //       if (period === "months") valueInDays = value * 30
              //
              //       if (valueInDays < daysDiff) {
              //         return Promise.reject(
              //           new Error(`Duration must be at least ${daysDiff} days`)
              //         )
              //       }
              //     }
              //     return Promise.resolve()
              //   }
              // })
            ]}
          >
            <InputNumber
              min={1}
              placeholder="Enter duration"
              className="w-full"
              max={99999999}
              addonAfter={
                <Form.Item<ContractFormData>
                  name={[key, "duration_type"]}
                  noStyle
                  initialValue="days"
                  rules={[
                    { required: true, message: "Please select duration type" }
                  ]}
                >
                  <Select
                    style={{ width: 100 }}
                    options={[
                      { value: "days", label: "Days" },
                      { value: "weeks", label: "Weeks" },
                      { value: "months", label: "Months" }
                    ]}
                  />
                </Form.Item>
              }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "start_date"]}
            label="Start Date"
            dependencies={[[key, "completion_date"]]}
            getValueProps={getDateValueProps}
            rules={createDateRangeRules<ContractFormData>(
              [key, "completion_date"],
              "start"
            )}
          >
            <DatePicker
              className="w-full"
              onChange={dateAutoFill<ContractFormData>({
                form,
                endDatePath: ["project", "completion_date"]
              })}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "completion_date"]}
            label="Completion Date"
            dependencies={[[key, "start_date"]]}
            getValueProps={getDateValueProps}
          >
            <DatePicker className="w-full" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<ContractFormData>
            name={[key, "prepared_by"]}
            label="Prepared By"
          >
            <TextInput disabled placeholder="Enter prepared by" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item<ContractFormData> name={[key, "summary"]} label="Summary">
            <TextArea rows={3} placeholder="Enter summary..." />
          </Form.Item>
        </Col>
      </Row>
    </DocumentCard>
  )
}
